import { makeStyles } from '@material-ui/core';
import { Separator } from '../types';

const useStyles = makeStyles(
  theme => ({
    root: {
      ...theme.typography.body2,
      color: theme.palette.secondary.main,
    },
  }),
  { name: 'SecondarySeparator' },
);

export const SecondarySeparator: Separator = () => {
  const classes = useStyles();

  // '&gt;' is '>'
  return <li className={classes.root}>&gt;</li>;
};
